export default "__VITE_ASSET__BxBL_Fd2__"